import {AfterViewChecked, Component, OnInit} from '@angular/core';
import {DataService} from '../../../Services/data.service';
import {StorageService} from '../../../Services/storage.service';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {FilterPipe} from 'ngx-filter-pipe';
import {Title} from '@angular/platform-browser';
import {ConfirmDialogService} from '../../../Services/confirm-dialog.service';
import {ResponseModel} from '../../../DataModels/response-model';
import {BsToastService} from '../../../Services/bs-toast-service';
import {RoutingTrackerService} from '../../../Services/routing-tracker.service';
import {NavigationService} from '../../../Services/navigation.service';
import {PrintBuilderService} from '../../../Services/print-builder.service';
import {catchError, first, map} from 'rxjs/operators';
import {firstValueFrom, Observable, of} from 'rxjs';
import {EmailModel} from '../../../DataModels/email-model';


@Component({
  selector: 'app-shipment-form',
  templateUrl: './shipment-form.component.html',
  styleUrls: ['./shipment-form.component.css'],
  standalone: false
})
export class ShipmentFormComponent implements OnInit, AfterViewChecked {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: BsToastService,
    private datePipe: DatePipe,
    private titleService: Title,
    private confirmDialogService: ConfirmDialogService,
    public prevUrl: RoutingTrackerService,
    private printBuilder: PrintBuilderService,
    private nav: NavigationService
  ) {
    this.vm.buttonsDisabled = false;
    this.vm.shipmentInvoices = [];
    this.vm.accountFilter = [];
    this.vm.orderList = [];
    this.vm.account = [];
    this.vm.currency = [];
    this.vm.is_init = false;
    this.vm.printItem = [];
    this.vm.shipmentAttachments = [];
    this.vm.orderInput = [];
    this.vm.isLoaded = false;
    this.vm.order = {};

    const prevUrl2 = this.prevUrl.getPreviousUrl();

    if (prevUrl2 !== null && prevUrl2 !== undefined) {
      this.routedFrom = prevUrl2;
    } else {
      this.routedFrom = '';
    }
  }
  vm: any = {
    item: {
      detail: {
        quantity: 0,
        shipped_quantity: 0,
        linked_detail_id: 0,
        backOrder_quantity: 0
      },
    },
  };
  shipmentId: string;
  sales: string | boolean;
  purchases: string | boolean;
  batchId: string;
  orderId: string;
  action: string;
  // If set via query param from list, triggers auto print without using action=print
  private autoPrintFlag: boolean = false;
  type: string;
  subLedger: string;

  backOrder: number;

  buttonConfig: any = {
    save: true,
    close: true,
    reset: false,
    delete: true,
    saveNew: false,
    saveClose: true,
    print: true,
    email: true,
  };

  submitted = false;
  locked = false;
  routedFrom = '';

  protected readonly window = window;

  // Lookup maps for faster access (built after lookups load)
  private itemById: Record<string, any> = {};
  private uomById: Record<string, any> = {};
  private companyById: Record<string, any> = {};
  private locationById: Record<string, any> = {};
  private inventoryLoading = false;

  // Email support (consumed by common Send Email modal)
  emailDocumentName: string = 'Shipment';
  reportDataToSendInEmail: EmailModel = new EmailModel();

  // Internal flag to ensure auto-print from list happens only once per load
  private autoPrintHandled = false;

  originalSnapshot: any = null;


  ngOnInit() {
    this.vm.isLoaded = false;

    // Use first() operator to automatically unsubscribe after first emission
    this.route.queryParamMap.pipe(
      first()
    ).subscribe(params => this.initializeComponent(params));
  }

  buildSnapshot(): any {
    return structuredClone(this.vm.item);
  }

  private buildSnapshotDiffs(original: any, current: any): { path: string; current: any; original: any }[] {
    const diffs: { path: string; current: any; original: any }[] = [];
    const isObject = (value: any) => value !== null && typeof value === 'object';

    const walk = (path: string, orig: any, curr: any) => {
      if (orig === curr) {
        return;
      }

      const origIsObject = isObject(orig);
      const currIsObject = isObject(curr);

      if (origIsObject && currIsObject) {
        if (Array.isArray(orig) || Array.isArray(curr)) {
          const origArray = Array.isArray(orig) ? orig : [];
          const currArray = Array.isArray(curr) ? curr : [];
          const maxLength = Math.max(origArray.length, currArray.length);
          for (let index = 0; index < maxLength; index += 1) {
            walk(`${path}[${index}]`, origArray[index], currArray[index]);
          }
          return;
        }

        const keys = new Set<string>([
          ...Object.keys(orig || {}),
          ...Object.keys(curr || {})
        ]);

        keys.forEach(key => {
          const nextPath = path ? `${path}.${key}` : key;
          walk(nextPath, orig?.[key], curr?.[key]);
        });
        return;
      }

      diffs.push({
        path,
        current: curr,
        original: orig
      });
    };

    walk('', original, current);
    return diffs;
  }

  hasChanges(): boolean {
    if (!this.originalSnapshot) {
      return false;
    }

    return JSON.stringify(this.buildSnapshot()) !== JSON.stringify(this.originalSnapshot);
  }

  checkForChanges(): boolean {
    return this.hasChanges();
  }

  private refreshBaseline(): void {
    this.originalSnapshot = structuredClone(this.buildSnapshot());
  }


  /**
   * Initialize component with route parameters
   * @param params Route parameters
   */
  private initializeComponent(params: ParamMap): void {
    // Extract route parameters
    this.extractRouteParameters(params);

    // Initialize item based on shipment type
    this.initializeItem();

    // Set default item collections
    this.initializeItemCollections();

    // Load required data
    this.initializeData().then();

    // Call init() if needed
    if (!this.vm.is_init) {
      this.init();
    }
  }

  /**
   * Extract and set route parameters
   */
  private extractRouteParameters(params: ParamMap): void {
    this.shipmentId = params.get('shipmentId');
    this.batchId = params.get('batchId');
    this.orderId = params.get('orderId');
    this.action = params.get('action');
    this.type = params.get('type');
    this.subLedger = params.get('subLedger');
    const ap = params.get('autoPrint');
    this.autoPrintFlag = ap === '1' || ap === 'true' || ap === 'yes';
  }

  /**
   * Initialize item based on shipment type
   */
  private initializeItem(): void {
    this.vm.item = {};
    this.vm.buttonsDisabled = false;

    if (this.shipmentId === 'newSS') {
      this.vm.item = {batchTypeId: '11'};
      this.subLedger = 'ar';
    } else if (this.shipmentId === 'newPS') {
      this.vm.item = {batchTypeId: '12'};
      this.subLedger = 'ap';
    } else {
      this.vm.is_init = true;
      this.loadItem().then();
    }
  }

  /**
   * Initialize item collections with empty arrays
   */
  private initializeItemCollections(): void {
    this.vm.item.header = [];
    this.vm.item.detail = [];
    this.vm.item.attachments = [];
    this.vm.item.shipments = [];
    this.vm.linkedOrders = [];
    this.vm.showOrderPicker = false;
    this.vm.orderPickerFilter = '';
    this.vm.orderPickerMatchShipTo = true;
    this.vm.addOrderInput = null;
  }


  ngAfterViewChecked() {
    this.titleService.setTitle(this.vm.title);
  }

  async initializeData() {
    const isNewShipment = this.shipmentId === 'newSS' || this.shipmentId === 'newPS';
    // Set sales/purchases flags early so loadOrdersList() sends the correct order type filter
    // Rule: sales = batch type 11 (AR), purchases = batch type 12 (AP)
    this.sales = this.shipmentId === 'newSS' || String(this.subLedger).toLowerCase() === 'ar';
    this.purchases = this.shipmentId === 'newPS' || String(this.subLedger).toLowerCase() === 'ap';

    // For existing shipments, load the item first so entity_id is available for loadOrdersList
    if (!isNewShipment) {
      await Promise.allSettled([
        this.loadItem(),
        this.loadBillingAddress(),
        this.loadShipToAddress(),
        this.loadEntityContact()
      ]);
    }

    const loadingTasks = [
      this.loadCompany(),
      this.loadCurrency(),
      this.loadOrdersList(),
      this.loadEntity(),
      // Lazy-load inventory items later only if needed to map detail item codes.
      this.loadLocation(),
      this.loadUOM()
    ];

    // Fire all tasks simultaneously and wait for all to complete
    const results = await Promise.allSettled(loadingTasks);

    const taskNames = [
      'Company', 'Currency', 'OrdersList', 'Entity',
      'Location', 'UOM'
    ];

    results.forEach((result, index) => {
      if (result.status === 'rejected') {
        console.error(`Failed to load ${taskNames[index]}:`, result.reason);
      }
    });

    // Explicitly wait for all tasks to complete before continuing
    await this.continueProcessing();
  }

  private async continueProcessing() {
    // Build lookup maps for faster subsequent access
    this.buildLookupMaps();

    this.init();
    // this.processEntityOrderInfo();

    if (this.orderId) {
      this.loadOrder(this.orderId);
    }
  }

  async loadItem() {
    try {
      this.submitted = true;
      const result = await firstValueFrom(this.tableDataService.getData('entry', this.shipmentId));
      this.vm.item = result;
      this.locked = this.vm.item.batch.locked;
      return result;
    } catch (error) {
      console.error('Failed to load Item:', error);
      throw error;
    }
  }

  async loadUOM() {
    try {
      const value = await firstValueFrom(
        this.tableDataService.getData('uom', '?state=active&pageNumber=0&pageSize=999999')
      );
      this.vm.uom = value.Data;
      return value;
    } catch (error) {
      console.error('Failed to load UOM:', error);
      throw error;
    }
  }

  async loadCompany() {
    try {
      const value = await firstValueFrom(
        this.tableDataService.getData('company', '?state=active&pageNumber=0&pageSize=999999')
      );
      this.vm.company = value.Data;
      return value;
    } catch (error) {
      console.error('Failed to load Company:', error);
      throw error;
    }
  }

  async loadCurrency() {
    try {
      const value = await firstValueFrom(
        this.tableDataService.getData('currency', '?state=active&pageNumber=0&pageSize=999999')
      );
      this.vm.currency = value.Data;
      return value;
    } catch (error) {
      console.error('Failed to load Currency:', error);
      throw error;
    }
  }

  async loadEntity() {
    try {
      const value = await firstValueFrom(
        this.tableDataService.getData('entity', '?state=active&pageNumber=0&pageSize=999999')
      );
      this.vm.entity = value.Data;
      return value;
    } catch (error) {
      console.error('Failed to load Entity:', error);
      throw error;
    }
  }

  async loadLocation() {
    try {
      const value = await firstValueFrom(
        this.tableDataService.getData('location', '?state=active&pageNumber=0&pageSize=999999')
      );
      this.vm.location = value.Data;
      return value;
    } catch (error) {
      console.error('Failed to load Location:', error);
      throw error;
    }
  }

  async loadInventoryItem() {
    try {
      const value = await firstValueFrom(
        this.tableDataService.getData('item', '?state=active&pageNumber=0&pageSize=999999')
      );
      this.vm.inventoryItem = value.Data;
      // Build lookup map for items
      if (Array.isArray(this.vm.inventoryItem)) {
        this.itemById = {};
        for (const it of this.vm.inventoryItem) {
          if (it && it.id != null) {
            this.itemById[String(it.id)] = it;
          }
        }
      }
      return value;
    } catch (error) {
      console.error('Failed to load Inventory Item:', error);
      throw error;
    }
  }

  private buildLookupMaps(): void {
    // Build simple id->object maps for quick lookups
    if (Array.isArray(this.vm.uom)) {
      this.uomById = {};
      for (const u of this.vm.uom) {
        if (u && u.id != null) {
          this.uomById[String(u.id)] = u;
        }
      }
    }
    if (Array.isArray(this.vm.company)) {
      this.companyById = {};
      for (const c of this.vm.company) {
        if (c && c.id != null) {
          this.companyById[String(c.id)] = c;
        }
      }
    }
    if (Array.isArray(this.vm.location)) {
      this.locationById = {};
      for (const l of this.vm.location) {
        if (l && l.id != null) {
          this.locationById[String(l.id)] = l;
        }
      }
    }
    if (Array.isArray(this.vm.inventoryItem)) {
      this.itemById = {};
      for (const it of this.vm.inventoryItem) {
        if (it && it.id != null) {
          this.itemById[String(it.id)] = it;
        }
      }
    }
  }

  private async ensureInventoryLoaded(): Promise<void> {
    if (Array.isArray(this.vm.inventoryItem) && this.vm.inventoryItem.length) {
      return;
    }
    if (this.inventoryLoading) {
      return;
    }
    this.inventoryLoading = true;
    try {
      await this.loadInventoryItem();
    } finally {
      this.inventoryLoading = false;
      this.buildLookupMaps();
    }
  }

  async loadBillingAddress() {
    try {
      const paramString = `billing_address=1&entity_id=${this.vm.item.header.entity_id || ''}`;
      const result = await firstValueFrom(
        this.tableDataService.getApiListData('entity_address/addresses', `?${paramString}`)
      );
      this.vm.billToAddress = result.Data;

      if (this.vm.billToAddress.length === 1) {
        this.vm.item.header.bill_address_id = this.vm.billToAddress[0].id;
      }

      return result;
    } catch (error) {
      console.error('Failed to load Billing Address:', error);
      throw error;
    }
  }

  async loadShipToAddress() {
    try {
      const paramString = `billing_address=0&entity_id=${this.vm.item.header.entity_id || ''}`;
      const result = await firstValueFrom(
        this.tableDataService.getApiListData('entity_address/addresses', `?${paramString}`)
      );
      this.vm.shipToAddress = result.Data;

      if (this.vm.shipToAddress.length === 1) {
        this.vm.item.header.ship_address_id = this.vm.shipToAddress[0].id;
      }

      return result;
    } catch (error) {
      console.error('Failed to load Ship To Address:', error);
      throw error;
    }
  }

  async loadEntityContact() {
    try {
      const paramString = `entity_id=${this.vm.item.header.entity_id || ''}`;
      const result = await firstValueFrom(
        this.tableDataService.getData('entity_contact', `?${paramString}`)
      );
      this.vm.contact = result;
      return result;
    } catch (error) {
      console.error('Failed to load Entity Contact:', error);
      throw error;
    }
  }

  async loadOrdersList() {
    try {
      const value: ResponseModel = await firstValueFrom(
        this.tableDataService.getApiListData('OrderList', `?sales=${this.sales}&entity_id=${this.vm.item.header.entity_id || ''}&pageNumber=0&pageSize=999999`)
      );
      this.vm.orderList = value.Data;
      // console.log('OrderList: ', this.vm.orderList);

      // add a friendly display name for typeahead
      this.vm.orderList.forEach((element, index) => {
        element.name = element.entity_name + ' &bullet; ' + element.number;
      });

      return value;
    } catch (error) {
      console.error('Failed to load OrderList:', error);
      throw error;
    }
  }


  processEntityOrderInfo() {
    let tempDesc = '';
    let formatedDate = '';
    // console.log('processEntityOrderInfo: ' + this.shipmentId);

    this.vm.orderList.forEach((element, index) => {
      // if (element.entity_id == this.vm.item.header.entity_id) {
      formatedDate = this.datePipe.transform(element.header_date, 'MM/dd/yyyy');
      if (element.description) {
        tempDesc = element.description;
      } else {
        tempDesc = 'test' + index;
      }
      this.vm.orderInput = element.name + ' ' + tempDesc + ' ' + formatedDate + ' ' + element.number;
      // console.log('orderinput3: ' + JSON.stringify(this.vm.orderInput));
      // }
    });

    // for (const [x, val] of Object.entries(this.vm.entity)) {
    //   console.log('processEntityOrderInfo: ' + JSON.stringify(this.vm.entity));
    //   if (this.shipmentId === 'newSS' || this.shipmentId === 'newPS') {
    //     // if (this.vm.orderList?.entity_id == this.vm.entity[x].id) {
    //     //   formatedDate = this.datePipe.transform(this.vm.orderList.header_date, 'MM/dd/yyyy');
    //     //   if (this.vm.orderList?.description) {
    //     //     tempDesc = this.vm.orderList.description;
    //     //   } else {
    //     //     tempDesc = '';
    //     //   }
    //     // }
    //     tempDesc = 'test' + [x];
    //     this.vm.orderInput = this.vm.entity[x].name + ' ' + tempDesc + ' ' + formatedDate + ' ' + this.vm.orderList.number;
    //     console.log('orderinput1: ' + JSON.stringify(this.vm.orderInput));
    //     break;
    //   } else {
    //     if (this.vm.order.header?.entity_id == this.vm.entity[x].id) {
    //       formatedDate = this.datePipe.transform(this.vm.order.header?.header_date, 'MM/dd/yyyy');
    //       if (this.vm.order.header?.description) {
    //         tempDesc = this.vm.order.header.description;
    //       }
    //       this.vm.orderInput = this.vm.entity[x].name + ' ' + tempDesc + ' ' + formatedDate + ' ' + this.vm.order.header.number;
    //       console.log('orderinput3: ' + JSON.stringify(this.vm.orderInput));
    //       break;
    //     }
    //   }
    // }
  }


// Method to format typeahead display
  typeaheadOnSelect(selectedItem: any) {
    this.vm.orderInput = selectedItem.id;
    this.fetchOrderData(selectedItem.id);
  }


  onClose(isSaveClose: boolean = false) {

    if (isSaveClose) {
      this.save();
    }

    // Navigate to the shipment list
    const subLedger = this.vm.subLedger;
    const route = '/transactions/shipment/list/' + subLedger;
    this.router.navigate([route], {queryParams: {type: 'shipments', subLedger}}).then();
  }

  isFieldEmpty(value: any): boolean {
    let retVal = false;
    retVal = !value;
    return retVal;
  }


  /**
   * Initializes the shipment form
   */
  async init() {
    const isNewShipment = this.shipmentId === 'newSS' || this.shipmentId === 'newPS';

    if (isNewShipment) {
      this.vm.item.batch = {};
    }

    this.initializeShipmentType(this.subLedger === 'ar');

    if (isNewShipment) {
      this.initializeNewShipment();
    } else {
      await this.initializeExistingShipment();
    }

    await this.normalizeDetailValues();
    await this.setUiDefaultValues();
    this.refreshBaseline();
    this.vm.isLoaded = true;

    // Auto-print when requested. Prefer the dedicated autoPrint flag to avoid save logic
    if (!this.autoPrintHandled && (this.autoPrintFlag || (this.action || '').toLowerCase() === 'print')) {
      this.autoPrintHandled = true;
      setTimeout(() => this.printAndReturnToList(), 0);
    }
  }

  /**
   * Initializes a new shipment
   */
  private initializeNewShipment(): void {
    // Set shipment type and ledger
    // if (this.subLedger === 'ar') (this.sales = true); else (this.sales = false)
    this.initializeShipmentType(this.subLedger === 'ar');

    // Set batch properties
    this.vm.item.batch.type_id = this.vm.item.batchTypeId;
    this.vm.item.header = {
      currency_rate: '1',
      header_date: this.datePipe.transform(new Date(), 'MM/dd/yyyy')
    };
    this.vm.item.detail = [];
    this.vm.item.shipments = [];
    this.vm.linkedOrders = [];

    // Set batch ID or description
    if (this.batchId) {
      this.vm.batchId = this.vm.item.batch.id = this.batchId;
    } else {
      this.vm.item.batch.description = 'Batch';
    }

    // Set shipment type name based on batch type
    this.setShipmentTypeName();
  }

  /**
   * Initializes an existing shipment for editing
   */
  private async initializeExistingShipment(): Promise<void> {
    // Set shipment type and ledger
    this.initializeShipmentType(this.subLedger === 'ar');

    // Set tab title now that shipmentTypeName is known
    this.vm.title = this.vm.shipmentTypeName + 'Shipment ' + this.vm.item.header.number;
    // Load linked orders from shipments array
    await this.loadLinkedOrdersFromShipments();

    // Format date
    this.vm.item.header.header_date = this.datePipe.transform(
      this.vm.item.header.header_date,
      'MM/dd/yyyy'
    );

    // Process inventory items in details
    await this.processDetailItems();

    // Load additional data
    await this.getOrderId();
    await this.getPriorShipments();
    this.calcTotal();

    // Load linked order if exists
    await this.loadLinkedOrder();

    this.addText();
    this.vm.isLoaded = true;

  }

  /**
   * Sets shipment type and ledger information
   * @param isSales Whether this is a sales shipment
   */
  private initializeShipmentType(isSales: boolean): void {
    if (isSales) {
      this.vm.subLedger = 'ar';
      this.vm.shipmentTypeClass = 'receivables';
      this.vm.shipmentTypeName = $localize`:Sales @@sales:Sales` + ' ';
      this.sales = true;
      this.purchases = false;
    } else {
      this.vm.subLedger = 'ap';
      this.vm.shipmentTypeClass = 'payables';
      this.vm.shipmentTypeName = $localize`:Purchase @@Purchase:Purchase` + ' ';
      this.sales = false;
      this.purchases = true;
    }
  }

  /**
   * Sets the shipment type name based on batch type
   */
  private setShipmentTypeName(): void {
    if (this.vm.item.batchTypeId == '11') {
      this.vm.shipmentTypeName = $localize`:Sales @@sales:Sales`;
    } else {
      this.vm.shipmentTypeName = $localize`:Purchase @@Purchase:Purchase`;
    }
  }

  /**
   * Loads linked orders from entry.shipments array (multi-order support)
   */
  private async loadLinkedOrdersFromShipments(): Promise<void> {
    this.vm.linkedOrders = [];
    const shipments: any[] = this.vm.item.shipments;
    if (!Array.isArray(shipments) || shipments.length === 0) {
      // Fallback: build from legacy linked_header_id
      if (this.vm.item.header?.linked_header_id) {
        const result: any = await firstValueFrom(
          this.tableDataService.getData('OrderList', this.vm.item.header.linked_header_id).pipe(first())
        );
        this.vm.linkedOrders = [{
          order_header_id: this.vm.item.header.linked_header_id,
          display: (result?.entity_name ?? '') + ' ' + (result?.number ?? '')
        }];
        this.vm.orderDisplay = this.vm.linkedOrders[0].display;
      }
      return;
    }
    for (const s of shipments) {
      if (!s.order_header_id) {
        continue;
      }
      try {
        const result: any = await firstValueFrom(
          this.tableDataService.getData('OrderList', s.order_header_id).pipe(first())
        );
        this.vm.linkedOrders.push({
          order_header_id: s.order_header_id,
          display: (result?.entity_name ?? '') + ' ' + (result?.number ?? '')
        });
      } catch {
        this.vm.linkedOrders.push({order_header_id: s.order_header_id, display: s.order_header_id});
      }
    }
    this.vm.orderDisplay = this.vm.linkedOrders[0]?.display ?? '';

    // Restore the UI-only tag used by the template grouping filter
    if (Array.isArray(this.vm.item.detail)) {
      const fallbackOrderId = this.vm.linkedOrders[0]?.order_header_id ?? null;
      for (const d of this.vm.item.detail) {
        if (!d._order_header_id) {
          // prefer the persisted per-line field, fall back to the single linked order
          d._order_header_id = d.order_header_id ?? d.linked_header_id ?? fallbackOrderId;
        }
      }
    }
  }

  /**
   * Processes inventory items in detail records
   */
  private async processDetailItems(): Promise<void> {
    // If inventory list isn't loaded yet, load it lazily and retry once.
    if (!this.vm.inventoryItem || !Array.isArray(this.vm.inventoryItem) || this.vm.inventoryItem.length === 0) {
      await this.ensureInventoryLoaded();
    }

    const isNewShipment = this.shipmentId === 'newSS' || this.shipmentId === 'newPS';

    for (const [x, _val] of Object.entries(this.vm.item.detail)) {
      const detail: any = this.vm.item.detail[x];

      // Set item code via O(1) map lookup if available
      if (detail?.item_id && this.itemById && this.itemById[String(detail.item_id)]) {
        detail.item_code = this.itemById[String(detail.item_id)].code;
      }

      // Convert string values to numbers for calculations
      if (detail?.amount !== undefined && detail?.amount !== null && detail?.amount !== '') {
        detail.amount = Number(detail.amount);
      }
      if (detail?.quantity !== undefined && detail?.quantity !== null && detail?.quantity !== '') {
        detail.quantity = Number(detail.quantity);
      }

      if (isNewShipment && (detail?.shipped_quantity === undefined || detail?.shipped_quantity === null || detail?.shipped_quantity === '')) {
        detail.shipped_quantity = Number(detail.quantity);
      }
    }
  }

  /**
   * Loads linked order information
   */
  private async loadLinkedOrder(): Promise<void> {
    if (this.vm.item.header.linked_header_id) {
      const paramString = `id=${this.vm.item.header.linked_header_id}`;
      const result: any = await firstValueFrom(
        this.tableDataService.getApiListData('entry', `?${paramString}`)
          .pipe(first())
      );
      const tempLinked = result.Data;
      if (tempLinked && tempLinked.header) {
        this.vm.orderNumber = tempLinked.header.number;
        this.vm.orderId = tempLinked.header.id;
      }
      this.countItems('0');
    }
  }

  /**
   * Normalizes numeric values in detail records
   */
  private async normalizeDetailValues(): Promise<void> {
    const details = this.vm?.item?.detail;
    if (!Array.isArray(details) || details.length === 0) {
      return;
    }

    for (let index = 0; index < details.length; index += 1) {
      const detail = details[index];
      if (detail?.debit_credit) {
        detail.debit_credit = Number(detail.debit_credit);
      }
    }
  }

  /**
   * Sets default values when only one option is available
   */
  private async setUiDefaultValues(): Promise<void> {
    const header = this.vm?.item?.header;
    if (!header) {
      return;
    }

    const company = this.vm.company;
    if (company?.length === 1 && !header.company_id) {
      header.company_id = company[0].id;
    }

    const currency = this.vm.currency;
    if (currency?.length === 1 && !header.currency_id) {
      header.currency_id = currency[0].id;
    }

    const location = this.vm.location;
    if (location?.length === 1 && !header.location_id) {
      header.location_id = location[0].id;
    }
  }

  /**
   * Load order details by ID and populate component data
   * @param orderId - The ID of the order to load
   */
  loadOrder(orderId: string): void {
    // console.log('loadOrder: ' + orderId);

    this.tableDataService
      .getData('entry', orderId)
      .pipe(first())
      .subscribe({
        next: (result: any) => {
          this.vm.order = result;
          // console.log('order: ', this.vm.order);

          this.populateOrderData();
          this.setOrderInput();
          this.mapOrderToHeader();
          this.initializeBatchInfo();
          this.updateDetailQuantities();
          this.loadAddressesAndContacts();
          // Set primary linked order
          if (!Array.isArray(this.vm.linkedOrders)) {
            this.vm.linkedOrders = [];
          }
          if (!Array.isArray(this.vm.item.shipments)) {
            this.vm.item.shipments = [];
          }
          const primaryId = this.vm.order.header.id;
          const entityMatch = this.vm.entity?.find((e: any) => e.id === this.vm.order.header.entity_id);
          const display = (entityMatch?.name ?? '') + ' ' + (this.vm.order.header.number ?? '');
          if (this.vm.linkedOrders.length === 0) {
            this.vm.linkedOrders = [{order_header_id: primaryId, display, number: this.vm.order.header.number}];
            this.vm.item.shipments = [{order_header_id: primaryId}];
          } else {
            this.vm.linkedOrders[0] = {order_header_id: primaryId, display, number: this.vm.order.header.number};
            this.vm.item.shipments[0] = {order_header_id: primaryId};
          }
          this.vm.item.header.comment = 'Orders: ' + this.vm.linkedOrders.map((o: any) => o.number).filter(Boolean).join(', ');
        },
        error: (error) => {
          console.error('Error loading order:', error);
          // Consider adding user notification here
        }
      });
  }

  /**
   * Populate order detail data
   */
  private populateOrderData(): void {
    // Deep-copy order detail lines and tag each with order quantities
    this.vm.item.detail = (this.vm.order.detail ?? []).map((line: any) => ({
      ...line,
      order_quantity: line.quantity,
      shipped_quantity: line.quantity,
      linked_detail_id: line.id,
      _order_header_id: this.vm.order.header.id
    }));
    this.vm.orderNumber = this.vm.order.header.number;
  }

  /**
   * Set order input display text
   */
  private setOrderInput(): void {
    const entityMatch = this.vm.entity.find(entity => entity.id === this.vm.order.header.entity_id);

    if (entityMatch) {
      const formattedDate = this.datePipe.transform(this.vm.order.header.header_date, 'MM/dd/yyyy');
      const description = this.vm.order.header.description || '';

      this.vm.orderInput = `${entityMatch.name} ${description} ${formattedDate} ${this.vm.order.header.number}`;
    }

    // Set the order input to order ID for the control
    this.vm.orderInput = this.vm.order.header.id;
  }

  /**
   * Map order header fields to item header
   */
  private mapOrderToHeader(): void {
    // Use object spread to copy multiple properties at once
    this.vm.item.header = {
      ...this.vm.item.header,
      company_id: this.vm.order.header.company_id,
      currency_id: this.vm.order.header.currency_id,
      location_id: this.vm.order.header.location_id,
      entity_id: this.vm.order.header.entity_id,
      bill_address_id: this.vm.order.header.bill_address_id,
      ship_address_id: this.vm.order.header.ship_address_id,
      term_id: this.vm.order.header.term_id,
      linked_header_id: this.vm.order.header.id,
      comment: this.vm.order.header.comment,
      reference: this.vm.order.header.reference,
      description: this.vm.order.header.description,
      batch_id: ''
    };
  }

  /**
   * Initialize batch information
   */
  private initializeBatchInfo(): void {
    this.vm.item.batch = {
      description: '',
      id: '',
      type_id: this.sales ? 11 : 12
    };
  }

  /**
   * Update detail quantities based on order
   */
  private updateDetailQuantities(): void {
    if (!this.vm.item.detail || !Array.isArray(this.vm.item.detail)) {
      return;
    }

    this.vm.item.detail.forEach(detail => {
      const orderDetail = this.vm.order.detail.find(od => od.id === detail.linked_detail_id);
      if (orderDetail) {
        detail.order_quantity = orderDetail.quantity;
        detail.shipped_quantity = orderDetail.quantity;
        detail.linked_detail_id = orderDetail.id;
      }
    });
  }

  /**
   * Load addresses and contact information for the entity
   */
  private loadAddressesAndContacts(): void {
    const entityId = this.vm.item.header.entity_id;
    if (!entityId) {
      return;
    }

    // Load billing addresses
    this.loadAddresses(true, entityId).subscribe(
      addresses => {
        this.vm.billToAddress = addresses;
        if (this.vm.billToAddress.length === 1 && !this.vm.item.header.bill_address_id) {
          this.vm.item.header.bill_address_id = this.vm.billToAddress[0].id;
        }
      }
    );

    // Load shipping addresses
    this.loadAddresses(false, entityId).subscribe(
      addresses => {
        this.vm.shipToAddress = addresses;
        if (this.vm.shipToAddress.length === 1 && !this.vm.item.header.ship_address_id) {
          this.vm.item.header.ship_address_id = this.vm.shipToAddress[0].id;
        }
      }
    );

    // Load contacts
    this.loadContacts(entityId).subscribe(
      contacts => {
        this.vm.contact = contacts;
      }
    );
  }

  /**
   * Load addresses for the given entity
   * @param isBillingAddress - Whether to load billing (true) or shipping (false) addresses
   * @param entityId - The entity ID
   * @returns Observable of addresses
   */
  private loadAddresses(isBillingAddress: boolean, entityId: string): Observable<any[]> {
    const paramString = `billing_address=${isBillingAddress ? 1 : 0}&entity_id=${entityId}`;

    return this.tableDataService.getApiListData('entity_address/addresses', '?' + paramString)
      .pipe(
        map((response: any) => response.Data),
        catchError(error => {
          console.error(`Error loading ${isBillingAddress ? 'billing' : 'shipping'} addresses:`, error);
          return of([]);
        })
      );
  }

  /**
   * Load contacts for the given entity
   * @param entityId - The entity ID
   * @returns Observable of contacts
   */
  private loadContacts(entityId: string): Observable<any[]> {
    const paramString = `entity_id=${entityId}`;

    return this.tableDataService.getData('entity_contact', '?' + paramString)
      .pipe(
        catchError(error => {
          console.error('Error loading contacts:', error);
          return of([]);
        })
      );
  }


  /**
   * Retrieves and processes order data either from an existing order or by entity name
   */
  private async getOrderId(): Promise<void> {
    if (this.vm.item.header.id) {
      await this.loadExistingOrder();
      return;
    }

    await this.loadOrderByEntityName();
  }

  /**
   * Loads an existing order based on linked header ID
   */
  private async loadExistingOrder(): Promise<void> {
    const headerId = this.vm.item.header.linked_header_id;
    const result = await firstValueFrom(
      this.tableDataService.getData('entry', headerId)
        .pipe(first()) // Automatically unsubscribe after first emission
    );
    this.vm.order = result;
    this.updateDetailOrderQuantities();
  }

  /**
   * Updates detail order quantities based on matching items from the order
   */
  private updateDetailOrderQuantities(): void {
    if (!this.vm.item.detail || !this.vm.order.detail) {
      return;
    }

    // Create a map of item_id to quantity for faster lookup
    const orderDetailMap = new Map(
      this.vm.order.detail.map(detail => [detail.item_id, detail.quantity])
    );

    // Update quantities using the map for O(1) lookups
    this.vm.item.detail.forEach(detail => {
      const orderQuantity = orderDetailMap.get(detail.item_id);
      if (orderQuantity !== undefined) {
        detail.order_quantity = orderQuantity;
      }
    });
  }

  /**
   * Loads order by matching entity name in order list
   */
  private async loadOrderByEntityName(): Promise<void> {
    const batchTypeId = this.getBatchTypeId();
    const matchingOrder = this.findMatchingOrder();

    if (!matchingOrder) {
      return;
    }

    await this.loadOrderData(matchingOrder.id, batchTypeId);
    this.loadEntityData(this.vm.item.header.entity_id);
  }

  /**
   * Gets the batch type ID from vm.item or defaults to 11
   */
  private getBatchTypeId(): number {
    return this.vm.item.batchTypeId ? Number(this.vm.item.batchTypeId) : 11;
  }

  /**
   * Finds an order in the order list that matches the input entity name
   */
  private findMatchingOrder(): any {
    if (!this.vm.orderList || !Array.isArray(this.vm.orderList)) {
      return null;
    }

    return this.vm.orderList.find(order => order.entity_name === this.vm.orderInput);
  }

  /**
   * Loads order data and updates vm.item properties
   * @param orderId The order ID to load
   * @param batchTypeId The batch type ID to set
   */
  private async loadOrderData(orderId: string, batchTypeId: number): Promise<void> {
    this.vm.order_id = orderId;

    const result = await firstValueFrom(
      this.tableDataService.getData('entry', orderId)
        .pipe(first())
    );
    this.vm.order = result;
    this.vm.item = this.vm.order;

    // Preserve the current header date
    const currentDate = this.vm.item.header.header_date;

    // Set batch information
    this.setOrderBatchInfo(batchTypeId);

    // Reset ID fields
    this.resetOrderIds();

    // Restore header date and update header fields
    this.updateOrderHeaderFields(currentDate, orderId);

    // Update detail quantities
    this.updateOrderDetailQuantities();
  }

  /**
   * Sets batch information for the order
   */
  private setOrderBatchInfo(batchTypeId: number): void {
    this.vm.item.number = this.vm.order.header.number;
    this.vm.item.batch.id = undefined;
    this.vm.item.batch.type_id = batchTypeId;
  }

  /**
   * Resets IDs for new order
   */
  private resetOrderIds(): void {
    this.vm.item.header.id = undefined;
    this.vm.item.header.batch_id = undefined;
  }

  /**
   * Updates order header fields
   */
  private updateOrderHeaderFields(headerDate: any, orderId: string): void {
    this.vm.item.header.header_date = headerDate;
    this.vm.item.header.entity_id = this.vm.order.header.entity_id;
    this.vm.item.header.location_id = this.vm.order.header.location_id;
    this.vm.item.header.bill_address_id = this.vm.order.header.bill_address_id;
    this.vm.item.header.ship_address_id = this.vm.order.header.ship_address_id;
    this.vm.item.header.currency_id = this.vm.order.header.currency_id;
    this.vm.item.header.term_id = this.vm.order.header.term_id;
    this.vm.item.header.linked_header_id = orderId;
  }

  /**
   * Updates order detail quantities
   */
  private updateOrderDetailQuantities(): void {
    if (!this.vm.item.detail) {
      return;
    }

    this.vm.item.detail.forEach(detail => {
      detail.order_quantity = detail.quantity;
      detail.shipped_quantity = detail.quantity;
      detail.linked_detail_id = detail.id;
    });
  }

  /**
   * Loads entity-related data (addresses and contacts)
   */
  private loadEntityData(entityId: string): void {
    if (!entityId) {
      return;
    }

    // Load billing addresses
    this.loadEntityAddresses(entityId, true);

    // Load shipping addresses
    this.loadEntityAddresses(entityId, false);

    // Load contacts
    this.loadEntityContacts(entityId);
  }

  /**
   * Loads entity addresses
   */
  private loadEntityAddresses(entityId: string, isBillingAddress: boolean): void {
    const paramString = `billing_address=${isBillingAddress ? 1 : 0}&entity_id=${entityId}`;

    this.tableDataService.getData('entity_address/addresses', '?' + paramString)
      .pipe(first())
      .subscribe(result => {
        if (isBillingAddress) {
          this.vm.billToAddress = result;
        } else {
          this.vm.shipToAddress = result;
        }
      });
  }

  /**
   * Loads entity contacts
   */
  private loadEntityContacts(entityId: string): void {
    const paramString = `entity_id=${entityId}`;

    this.tableDataService.getData('entity_contact', '?' + paramString)
      .pipe(first())
      .subscribe(result => {
        this.vm.contact = result;
      });
  }


  private async getPriorShipments(): Promise<void> {
    let paramString = '';
    paramString += 'shipment_id=' + this.vm.item.header.id;
    paramString += '&order_id=' + this.vm.item.header.linked_header_id;
    const result: any = await firstValueFrom(
      this.tableDataService.getApiListData('entry', '?' + paramString)
        .pipe(first())
    );
    this.vm.priorShipments = result.Data;
    for (const [x, val] of Object.entries(this.vm.item.detail)) {
      for (const [y, valY] of Object.entries(this.vm.priorShipments)) {
        if (this.vm.priorShipments[y].item_id == this.vm.item.detail[x].item_id) {
          this.vm.item.detail[x].prior_shipped_quantity = this.vm.priorShipments[y].prior_shipped_quantity;
          this.vm.item.detail[x].backOrder_quantity = this.vm.item.detail[x].quantity - (this.vm.item.detail[x].prior_shipped_quantity + this.vm.item.detail[x].quantity);
          // console.log(this.vm.item.detail[x].backOrder_quantity);
        }
      }
    }
  }

  private calcTotal() {
    let total = 0;
    for (const [x, val] of Object.entries(this.vm.item.detail)) {
      if (this.vm.item.detail[x].debit_credit) {
        if (!Number(this.vm.item.detail[x].debit_credit) && this.vm.item.detail[x].debit_credit != '-') {
          this.notification.showErrorToast(
            $localize`:Amount @@amount:Amount` +
              '" <strong>' +
              this.vm.item.detail[x].debit_credit +
              '</strong>" ' +
              $localize`:is not a number, please remove any text. @@isnotanumberpleaseremoveanytext:is not a number, please remove any text.` +
              '<br/>'
          );
        } else if (this.vm.item.detail[x].debit_credit != '-') {
          total += Number(this.vm.item.detail[x].debit_credit);
        }
      }
    }
    this.vm.total = Math.round(total * 100) / 100;
  }

  countItems(event: any) {
    this.vm.itemCount = 0;
    for (const [x, val] of Object.entries(this.vm.item.detail)) {

      if (!this.vm.item.detail[x].prior_shipped_quantity) {
        this.vm.item.detail[x].prior_shipped_quantity = 0;
      }
      // console.log('order: ' + this.vm.item.detail[x].order_quantity);
      // console.log('prior: ' + this.vm.item.detail[x].prior_shipped_quantity);
      // console.log('shipped: ' + this.vm.item.detail[x].shipped_quantity);

      this.vm.item.detail[x].backOrder_quantity = Number(this.vm.item.detail[x].order_quantity) - Number((this.vm.item.detail[x].prior_shipped_quantity)
        + Number(this.vm.item.detail[x].shipped_quantity));

      if (this.vm.item.detail[x].backOrder_quantity <= 0) {
        this.vm.item.detail[x].backOrder_quantity = 0;
      }
      // console.log('backorder: ' + this.vm.item.detail[x].backOrder_quantity);
      this.vm.itemCount += Number(this.vm.item.detail[x].shipped_quantity);
    }

  }

  print() {
    this.vm.action = 'print';
    for (const [x, val] of Object.entries(this.vm.item.detail)) {
      if (this.FilterObject(this.vm.uom, { id: this.vm.item.detail[x].uom_id }, true)[0] != undefined) {
        this.vm.item.detail[x].uom = this.FilterObject(
          this.vm.uom,
          { id: this.vm.item.detail[x].uom_id },
          true
        )[0].code;
      }
    }
    if (this.vm.item.header.entity_id) {
      if (this.FilterObject(this.vm.entity, { id: this.vm.item.header.entity_id }, true)[0] != undefined) {
        this.vm.item.header.entityInput = this.FilterObject(
          this.vm.entity,
          { id: this.vm.item.header.entity_id },
          true
        )[0].name;
      }
    }
    // this.vm.item.header.entityInput
    if (this.vm.item.header.bill_address_id) {
      if (this.FilterObject(this.vm.billToAddress, { id: this.vm.item.header.bill_address_id }, true)[0] != undefined) {
        const tempAddress = this.FilterObject(
          this.vm.billToAddress,
          { id: this.vm.item.header.bill_address_id },
          true
        )[0];
        this.vm.printItem.billToAddress1 = tempAddress.address_1;
        this.vm.printItem.billToAddress2 = tempAddress.city;
        if (tempAddress.state) {
          this.vm.printItem.billToAddress2 += ', ' + tempAddress.state;
        }
        this.vm.printItem.billToAddress2 += '  ' + tempAddress.zip;
      }
    }

    if (this.vm.item.header.ship_address_id) {
      if (this.FilterObject(this.vm.shipToAddress, { id: this.vm.item.header.ship_address_id }, true)[0] != undefined) {
        const tempAddress = this.FilterObject(
          this.vm.shipToAddress,
          { id: this.vm.item.header.ship_address_id },
          true
        )[0];
        this.vm.printItem.shipToAddress1 = tempAddress.address_1;
        this.vm.printItem.shipToAddress2 = tempAddress.city;
        if (tempAddress.state) {
          this.vm.printItem.shipToAddress2 += ', ' + tempAddress.state;
        }
        this.vm.printItem.shipToAddress2 += '  ' + tempAddress.zip;
      }
    }

    // set company address
    if (this.vm.item.header.company_id) {
      if (this.FilterObject(this.vm.company, { id: this.vm.item.header.company_id }, true)[0] != undefined) {
        const tempAddress = this.FilterObject(this.vm.company, { id: this.vm.item.header.company_id }, true)[0];
        this.vm.printItem.companyLogo = tempAddress.logo;
        this.vm.printItem.companyName = tempAddress.name;
        this.vm.printItem.companyAddress1 = tempAddress.address_1;
        this.vm.printItem.companyAddress2 = tempAddress.city;
        if (tempAddress.state) {
          this.vm.printItem.companyAddress2 += ', ' + tempAddress.state;
        }
        this.vm.printItem.companyAddress2 += '  ' + tempAddress.zip;
        this.vm.printItem.companyTaxNumber = tempAddress.tax_number;
        this.vm.printItem.companyPhone = tempAddress.phone;
      }
    }
    // Map item codes using O(1) lookup map (avoids nested loops over large inventories)
    if (!this.vm.inventoryItem || !Array.isArray(this.vm.inventoryItem) || this.vm.inventoryItem.length === 0) {
      this.ensureInventoryLoaded();
    }
    for (const [y, _valY] of Object.entries(this.vm.item.detail)) {
      const d: any = this.vm.item.detail[y];
      const it = d?.item_id != null ? this.itemById[String(d.item_id)] : null;
      if (it) {
        d.itemInput = it.code;
      }
    }

    if (
      this.action &&
      !this.vm.item.batch.locked
    ) {
      // Preserve original behavior: save before leaving/printing when allowed.
      this.save();
    } else {
      this.action = '';

      // Ensure UOM data is loaded (matches previous behavior), then build unified print HTML
      this.getTableData('uom', '?state=active&pageNumber=0&pageSize=999999', 'uom', (_value) => {
        try {
          // Ensure order number is available for print; derive from loaded order if missing
          try {
            if (!this.vm.orderNumber) {
              const possible = this.vm?.order?.header?.number || this.vm?.item?.order?.header?.number;
              if (possible) {
                this.vm.orderNumber = possible;
              }
            }
          } catch {
          }

          // Force shipment-specific layout regardless of subLedger ('ar'/'ap')
          const html = this.printBuilder.buildPrintHtml(this.vm, 'shipment');

          const iframe = document.createElement('iframe');
          iframe.style.position = 'fixed';
          iframe.style.right = '0';
          iframe.style.bottom = '0';
          iframe.style.width = '0';
          iframe.style.height = '0';
          iframe.style.border = '0';

          const doPrint = () => {
            try {
              iframe.contentWindow?.focus();
              iframe.contentWindow?.print();
            } catch {
            } finally {
              setTimeout(() => {
                try {
                  iframe.remove();
                } catch {
                }
              }, 400);
            }
          };

          iframe.onload = doPrint;
          (iframe as any).srcdoc = html;
          document.body.appendChild(iframe);
        } catch (err) {
          console.error('Failed to initiate shipment print', err);
          this.notification.showErrorToast($localize`:Unable to print document@@unableToPrint:Unable to print document`);
        } finally {
          this.vm.action = '';
        }
      });
    }
  }

  /**
   * Trigger print using the existing print() method, then navigate back to the
   * previous route (usually the shipment list). A small delay allows the print
   * dialog to open before routing away.
   */
  private printAndReturnToList() {
    try {
      this.print();
    } finally {
      const fallback = '/transactions/shipment/list' + this.subLedger;
      const backUrl = (typeof this.prevUrl?.getPreviousUrl === 'function' ? this.prevUrl.getPreviousUrl() : '') || this.routedFrom || fallback;
      setTimeout(() => {
        this.router.navigateByUrl(backUrl).catch(() => {
          // If navigation fails (e.g., deep link), try the fallback list URL
          this.router.navigateByUrl(fallback).catch(() => {
          });
        });
      }, 500);
    }
  }

  /**
   * Called by common header button (childEmail). Prepares the EmailModel for
   * the shared send-email modal, modeled after invoice-form.setEmailData().
   */
  email() {
    this.setEmailData();
  }

  /**
   * Build EmailModel for the shipment, using the same HTML used for printing.
   * Ensures the email modal receives a complete payload including pdfHtml.
   */
  setEmailData() {
    try {
      // Document display name
      this.emailDocumentName = 'Shipment';

      const emailDocObj = new EmailModel();
      emailDocObj.print_orientation = '1';
      emailDocObj.convert_attachment_to = 'pdf';
      emailDocObj.fromEmail = '';
      emailDocObj.fromName = 'AcctXErp';
      emailDocObj.header_id = String(this.vm?.item?.header?.id || this.shipmentId || '');
      emailDocObj.toEmail = '';
      emailDocObj.print_orientation = 'portait';
      emailDocObj.convert_attachment_to = 'pdf';

      const docNumber = this.vm?.item?.header?.number || '';
      emailDocObj.body = `Please see the attached Shipment - ${docNumber}.<br><br><br>` +
        'Best regards,' +
        '<br><br>' +
        'AcctXErp' +
        '<br><br>';
      emailDocObj.Subject = `AcctXErp ${this.emailDocumentName} - ${docNumber}`;
      emailDocObj.activity_message = this.emailDocumentName;

      // Generate HTML using shipment-specific builder
      try {
        emailDocObj.pdfHtml = this.printBuilder.buildEmailHtml(this.vm, 'shipment');
      } catch {
        emailDocObj.pdfHtml = '';
      }

      const safeName = (this.emailDocumentName || 'document').replace(/\s+/g, '_');
      if (docNumber) {
        emailDocObj.FileName = `${safeName}_${docNumber}.pdf`;
      } else {
        emailDocObj.FileName = `${safeName}.pdf`;
      }

      this.reportDataToSendInEmail = emailDocObj;
    } catch (err) {
      console.error('Failed to build shipment email data', err);
      // Provide a minimal fallback so the modal can still open
      const fallback = new EmailModel();
      fallback.Subject = 'AcctXErp Shipment';
      fallback.body = 'Please see the attached Shipment.';
      fallback.convert_attachment_to = 'pdf';
      fallback.print_orientation = '1';
      this.reportDataToSendInEmail = fallback;
    }
  }

  /**
   * Build the HTML used for emailing this shipment using the same
   * unified print builder used for printing. Consumers that send email
   * can call this to obtain the HTML payload.
   */
  buildEmailHtmlForShipment(): string {
    try {
      // Ensure email uses the same shipment layout
      return this.printBuilder.buildEmailHtml(this.vm, 'shipment');
    } catch {
      return '';
    }
  }

  save() {
    this.submitted = true;
    this.vm.buttonsDisabled = true;
    this.vm.errorDescription = '';
    // todo add condition for setting completed status based on invoiced and shipped
    // if (this.vm.tempCompleted) {
    //   this.vm.item.header.completed = this.vm.tempCompleted;
    // }

    for (const [x, valX] of Object.entries(this.vm.item.detail)) {
      this.vm.item.detail[x].quantity = this.vm.item.detail[x].shipped_quantity;
    }

    // check errors
    if (!this.vm.item.header.header_date) {
      this.vm.errorDescription += $localize`:Date is required. @@dateisrequired:Date is required.` + '<br/>';
      this.vm.dateMissing = true;
    } else {
      const yearEndDate = this.FilterObject(this.vm.company, { id: this.vm.item.header.company_id }, true)[0]
        .year_end_date;
      const cutOffDate = this.FilterObject(this.vm.company, { id: this.vm.item.header.company_id }, true)[0]
        .cut_off_date;
      const tempYearEndDate = new Date(yearEndDate);
      const tempCutOffDate = new Date(cutOffDate);
      const headerDate = new Date(this.vm.item.header.header_date);
      if (headerDate < tempYearEndDate) {
        this.vm.errorDescription +=
          $localize`:Date must be greater than the year end @@datemustbegreaterthantheyearend:Date must be greater than the year end` +
          ' ' +
          yearEndDate +
          '<br/>';
        this.vm.dateError = true;
      }
      if (headerDate < tempCutOffDate) {
        this.vm.errorDescription +=
          $localize`:Date must be greater than the cut off date @@datemustbegreaterthanthecutoffdate:Date must be greater than the cut off date` +
          ' ' +
          cutOffDate +
          '<br/>';
        this.vm.dateError = true;
      }
    }

    if (!this.vm.item.header.company_id) {
      this.vm.errorDescription += $localize`:Company is required. @@companyisrequired:Company is required.` + '<br/>';
      this.vm.companyError = true;
    }
    if (!this.vm.item.header.location_id) {
      this.vm.errorDescription +=
        $localize`:Location is required. @@locationisrequired:Location is required.` + '<br/>';
      this.vm.locationError = true;
    }
    if (!this.vm.item.header.currency_id) {
      this.vm.errorDescription += $localize`:Currency is required. @@currencyisrequired:Currency is required.` + '<br/>';
      this.vm.currencyError = true;
    }

    for (const [x, valX] of Object.entries(this.vm.item.detail)) {
      if (this.vm.item.detail[x].rowTotal) {
        if (!this.vm.item.detail[x].description) {
          this.vm.errorDescription +=
            $localize`:Detail description is required. @@detaildescriptionisrequired:Detail description is required.` +
            '<br/>';
        }
        if (!this.vm.item.detail[x].account_id) {
          this.vm.errorDescription +=
            $localize`:Detail account is required. @@detailaccountisrequired:Detail account is required.` + '<br/>';
        }
      }
    }

    if (!this.vm.item.header.description) {
      this.vm.errorDescription += $localize`:You must enter a Description @@mustEnterADescritpion:You must enter a Description`;
    }

    // if any errors stop
    if (this.vm.errorDescription) {
      this.notification.showWarningToast(this.vm.errorDescription);
      return;
    }

    // Rebuild shipments array from linkedOrders before posting
    if (Array.isArray(this.vm.linkedOrders) && this.vm.linkedOrders.length > 0) {
      this.vm.item.shipments = this.vm.linkedOrders.map((o: any) => ({order_header_id: o.order_header_id}));
      this.vm.item.header.linked_header_id = this.vm.linkedOrders[0].order_header_id;
    }

    if (this.vm.errorDescription === '') {
      if (!this.vm.item.header.signature || this.vm.item.header.signature == '') {
        // TODO maybe force sig? not sure. Maybe base on setting?
      }

      if (this.vm.item.header.id?.toUpperCase().includes('NEW') || this.vm.item.header.id == undefined || this.vm.item.header.id == '') {
        // new

        this.tableDataService.post('entry', this.vm.item).subscribe({
          next: (item: any) => {
            if (this.vm.action !== 'invoice' && this.vm.action !== 'print') {
              // this.notification.success($localize`:Saved@@saved:Saved`);
            }
            this.vm.buttonsDisabled = false;
            this.refreshBaseline();
            this.router.navigate(['transactions/shipment/form'], {
              queryParams: {shipmentId: item.id, type: this.type},
            }).then();
          },
          error: (error: { error: { Message: string }; statusText: string }) => {
            this.vm.buttonsDisabled = false;
            let ErrorMsg: string;
            if (typeof error.error.Message != 'undefined') {
              ErrorMsg = error.error.Message;
            } else {
              ErrorMsg = error.statusText;
            }
            // this.notification.error(ErrorMsg);
            console.log(ErrorMsg);
            if (this.vm.action == 'print') {
              window.print();
              this.vm.action = '';
            }
          }
        });
      } else {
        // edit
        //console.log('putting: ', this.vm.item);

        // diff
        const changes: any = {};

        changes.detail = this.vm.item.detail;
        changes.salesperson = this.vm.item.salesperson;
        changes.attachments = this.vm.item.attachments;
        changes.shipments = this.vm.item.shipments;

        const headerChanges: any = {};
        for (const key in this.vm.item.header) {
          if (Object.prototype.hasOwnProperty.call(this.vm.item.header, key)) {
            const value = this.vm.item.header[key];
            if (value !== key && key !== 'entityInput') {
              headerChanges[key] = value;
            }
          }
        }

        if (headerChanges) {
          changes.header = headerChanges;
        }

        // console.log('base obj: ', this.vm.item);
        // console.log('putting: ', changes);
        this.tableDataService.patch('entry', this.vm.item.header.id, changes).then(
          (item: any) => {
            this.vm.buttonsDisabled = false;
            this.refreshBaseline();
            // this.notification.success(item.description);
            if (this.vm.action === 'print') {
              window.print();
              this.vm.action = '';
            } else if (this.vm.action === 'invoice') {
              if (this.vm.subLedger == 'ar') {
                //  this.router.navigate(['/contact'],{queryParams: {part: 'navbar',search: 'contact', year: 2021 }})
                this.router.navigate(['transactions/invoice/ar/form'], {
                  queryParams: {documentId: 'newAR', shipmentId: this.vm.item.header.id},
                }).then();
              } else {
                this.router.navigate(['transactions/invoice/ap/form'], {
                  queryParams: {documentId: 'newAP', shipmentId: this.vm.item.header.id},
                }).then();
              }
              // this.vm.action = '';
            } else {
              // this.updateAttachments();
            }
            if (item.description == 'Deleted') {
              const subLedger = this.subLedger;
              if (this.subLedger == 'ar') {
                const route = 'transactions/shipment/list/' + subLedger;
                this.router.navigate([route], {
                  queryParams: {type: 'shipments', subLedger: 'ar'},
                }).then();
              } else {
                const route = 'transactions/shipment/list/' + subLedger;
                this.router.navigate([route], {
                  queryParams: {type: 'shipments', subLedger: 'ap'},
                }).then();
              }
            }
          },
          (error: { error: { Message: string }; statusText: string }) => {
            this.vm.buttonsDisabled = false;
            let ErrorMsg: string;
            if (typeof error.error.Message != 'undefined') {
              ErrorMsg = error.error.Message;
            } else {
              ErrorMsg = error.statusText;
            }
            console.log(ErrorMsg);
            // this.notification.error(ErrorMsg);
          }
        );
      }
    } else {
      // report error
      this.vm.buttonsDisabled = false;
      const arr = this.vm.errorDescription.split('<br/>');
      arr.forEach((item) => {
        if (item) {
          // this.notification.warning(item);
          // console.log(item);
        }
      });
    }
  }

  signature(signature) {
    this.vm.item.header.signature = signature;
    this.vm.getSignature = false;
    // this.vm.tempCompleted = true;
    document.getElementById('closeSignatureModel').click();
    this.save();
  }

  deleteSignature() {
    this.vm.item.header.signature = '';
    this.vm.getSignature = true;
    document.getElementById('closeSignatureModel').click();
    this.save();
  }

  syncItemAttachments(attachmentsArray: any) {
    // console.log('attachments array recvd in main');
    // console.log(attachmentsArray);

    // clear existing - will be put back because in array passed back in file upload array
    this.vm.item.attachments = [];

    // use the pieces needed for the api record
    attachmentsArray.forEach((x) => {
      this.vm.item.attachments.push({
        id: x.id,
        header_id: x.header_id,
        file_name: x.fileName,
        type: x.fileType,
        attachment: x.fileData,
        audit_sequence: 0
      });
    });
    // console.log('main vm array after sync to file upload data');
    // console.log(this.vm);
  }


  gotAnUploadFile(file: any) {
    // console.log('in got a file: ' + file);
    // console.log('in got a file: ');
  }


  generateInvoice() {
    const brClass = this;
    const messages: string[] = [
      $localize`:Generate Invoice for this Order? @@generateInvoiceForThisOrder:Generate Invoice for this Order?`,
      '',
    ];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.vm.action = 'invoice';
        this.vm.item.header.completed = true;
        this.save();
      },
      () => {
        brClass.notification.showSuccessToast($localize`:Deliver and Generate Canceled @@deliverAndGenerateCanceled:Deliver and Generate Canceled`);
        return;
      }
    );
  }

  delete() {
    const brClass = this;
    const messages: string[] = [
      $localize`:Delete this record? @@deletethisrecord:Delete this record?`,
      '',
    ];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.vm.item.header.deleted = true;
        this.save();
      },
      () => {
        brClass.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      }
    );
  }

  private getTableData(tableName, params, cacheName, fun) {
    // const cache = this.localStorage.StorageGet(cacheName);
    // if (cache) {
    //   fun(JSON.parse(cache));
    // }
    // else {

    this.tableDataService.getApiListData(tableName, params).subscribe((result: any) => {
      fun(result);
      // this.localStorage.StorageSet(cacheName, JSON.stringify(result));
      // console.log('table: ' + tableName + ' params: ' + params + ' return: ' + JSON.stringify(result));
    });
    // }
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  addText() {
    let text = $localize`:Shipment @@shipment:Shipment` + ' ';
    if (this.vm.item.header.number) {
      text += $localize`:Number @@number:Number` + ': ' + this.vm.item.header.number + '      ';
    }

    let itemCount = 0;
    for (const [x, value] of Object.entries(this.vm.item.detail)) {
      itemCount += Number(this.vm.item.detail[x].quantity);
    }

    text += $localize`:Item Count @@itemCount:Item Count` + ': ' + this.vm.itemCount;
    this.vm.addTextSignature = text;
    const canvas = document.getElementById('signature-pad') as HTMLCanvasElement;
    if (canvas) {
      const ctx = canvas.getContext('2d');
      ctx.font = '15px sans-serif';
      if (this.vm.addTextSignature) {
        ctx.fillText(this.vm.addTextSignature, 20, 270);
      }
    }
  }

  fetchOrderData(event: any) {
    this.orderId = event;
    this.loadOrder(this.orderId);
  }

  /**
   * Selects an order from the order picker table and loads its lines.
   * Handles both primary (first) and additional orders uniformly.
   */
  async selectOrder(orderId: string): Promise<void> {
    if (!orderId) {
      return;
    }
    if (!Array.isArray(this.vm.linkedOrders)) {
      this.vm.linkedOrders = [];
    }
    if (!Array.isArray(this.vm.item.shipments)) {
      this.vm.item.shipments = [];
    }
    if (!Array.isArray(this.vm.item.detail)) {
      this.vm.item.detail = [];
    }
    // Guard duplicates
    if (this.vm.linkedOrders.some((o: any) => o.order_header_id === orderId)) {
      return;
    }

    try {
      const result: any = await firstValueFrom(
        this.tableDataService.getData('entry', orderId).pipe(first())
      );
      if (!result) {
        return;
      }

      const isPrimary = this.vm.linkedOrders.length === 0;

      // Build display label
      const orderEntry = this.vm.orderList?.find((o: any) => o.id === orderId);
      const entityName = orderEntry?.entity_name ?? result.header?.entity_name ?? '';
      const orderNum = result.header?.number ?? '';
      const display = `${entityName} • Order: ${orderNum}`;

      // Tag each detail line with its source order
      const lines: any[] = (result.detail ?? []).map((d: any) => ({
        ...d,
        _order_header_id: orderId,
        _order_number: orderNum,
        _order_entity: entityName,
        shipped_quantity: d.quantity ?? 0,
        order_quantity: d.quantity ?? 0
      }));

      if (isPrimary) {
        // Primary order: set header fields from order
        this.vm.item.header = {
          ...this.vm.item.header,
          company_id: result.header.company_id,
          currency_id: result.header.currency_id,
          location_id: result.header.location_id,
          entity_id: result.header.entity_id,
          bill_address_id: result.header.bill_address_id,
          ship_address_id: result.header.ship_address_id,
          term_id: result.header.term_id,
          linked_header_id: orderId,
          comment: result.header.comment,
          reference: result.header.reference,
          description: result.header.description,
          batch_id: ''
        };
        this.vm.item.detail = lines;
        this.initializeBatchInfo();
        this.loadAddressesAndContacts();
      } else {
        // Additional order: append lines only
        this.vm.item.detail = [...this.vm.item.detail, ...lines];
      }

      this.vm.linkedOrders.push({order_header_id: orderId, display, number: orderNum, entity: entityName});
      this.vm.item.shipments.push({order_header_id: orderId});
      this.vm.item.header.linked_header_id = this.vm.linkedOrders[0].order_header_id;
      // Update comment to list all linked order numbers
      this.vm.item.header.comment = 'Orders: ' + this.vm.linkedOrders.map((o: any) => o.number).filter(Boolean).join(', ');

      // Process item codes on new lines
      await this.processDetailItems();
      this.countItems('0');
      this.vm.showOrderPicker = false;
    } catch (e) {
      console.error('selectOrder failed', e);
      this.notification.showErrorToast('Failed to load order');
    }
  }

  /**
   * Removes an order and all its tagged detail lines.
   * Primary order (index 0) cannot be removed.
   */
  removeLinkedOrder(index: number): void {
    if (index === 0) {
      return;
    }
    const orderId = this.vm.linkedOrders[index]?.order_header_id;
    this.vm.linkedOrders.splice(index, 1);
    this.vm.item.shipments.splice(index, 1);
    if (orderId) {
      this.vm.item.detail = this.vm.item.detail.filter((d: any) => d._order_header_id !== orderId);
    }
    this.vm.item.header.comment = 'Orders: ' + this.vm.linkedOrders.map((o: any) => o.number).filter(Boolean).join(', ');
    this.countItems('0');
  }

  /**
   * Adds a secondary order to an existing (saved) shipment.
   * Only appends lines; does not change header fields.
   */
  async addLinkedOrder(orderId: string): Promise<void> {
    await this.selectOrder(orderId);
    this.vm.addOrderInput = null;
  }

  /** Toggles the inline order picker panel */
  toggleOrderPicker(): void {
    this.vm.showOrderPicker = !this.vm.showOrderPicker;
    this.vm.orderPickerFilter = '';
    this.vm.orderPickerMatchShipTo = true;
  }

  /** Returns orders filtered for the picker (entity lock after primary + ship-to toggle + text search) */
  get filteredOrderList(): any[] {
    let list: any[] = this.vm.orderList ?? [];
    // Exclude already-selected orders
    const selectedIds = new Set((this.vm.linkedOrders ?? []).map((o: any) => o.order_header_id));
    list = list.filter((o: any) => !selectedIds.has(o.id));
    // After primary order is selected, lock to same entity
    if ((this.vm.linkedOrders ?? []).length > 0 && this.vm.item?.header?.entity_id) {
      list = list.filter((o: any) => o.entity_id === this.vm.item.header.entity_id);
    }
    // Ship-to filter
    if (this.vm.orderPickerMatchShipTo && this.vm.item?.header?.ship_address_id) {
      const shipTo = this.vm.item.header.ship_address_id;
      const matched = list.filter((o: any) => o.ship_address_id === shipTo);
      if (matched.length > 0) {
        list = matched;
      }
    }
    // Text search
    const q = (this.vm.orderPickerFilter ?? '').toLowerCase().trim();
    if (q) {
      list = list.filter((o: any) =>
        (o.number ?? '').toLowerCase().includes(q) ||
        (o.entity_name ?? '').toLowerCase().includes(q) ||
        (o.description ?? '').toLowerCase().includes(q)
      );
    }
    return list;
  }

  /** Toggles the line-item preview for an order row in the picker */
  async toggleOrderPreview(orderId: string): Promise<void> {
    if (!this.vm.orderPreview) {
      this.vm.orderPreview = {};
    }
    if (this.vm.orderPreview[orderId] && !this.vm.orderPreview[orderId].loading) {
      // collapse
      delete this.vm.orderPreview[orderId];
      return;
    }
    // Already loading — ignore double-click
    if (this.vm.orderPreview[orderId]?.loading) {
      return;
    }
    this.vm.orderPreview[orderId] = {loading: true, lines: []};
    try {
      const result: any = await firstValueFrom(
        this.tableDataService.getData('entry', orderId).pipe(first())
      );
      this.vm.orderPreview[orderId] = {loading: false, lines: result?.detail ?? []};
    } catch {
      this.vm.orderPreview[orderId] = {loading: false, lines: []};
    }
  }

  selectAccountModal(id) {
    // TODO
  }

  updateAccount() {
    // TODO
  }

  filterOrders(order: any) {
    // console.log('filterOrders', order);
    this.vm.orderInput = this.FilterObject(this.vm.orders, {number: order.order_number}, true);
  }
}
